import React, { Component, HTMLProps } from 'react';

class CustomInput extends Component<Props> {
  render() {
    const { inputType, className, ...rest } = this.props;
    return (
      <input
        className={`w-full focus:outline-none rounded bg-transparent hover:bg-white text-xs 2xl:text-md focus:formica-shadow  px-2 py-2 disabled:cursor-not-allowed ${this.getClasses()} ${className}`}
        {...rest}
      />
    );
  }

  private getClasses = () => {
    const { inputType } = this.props;
    switch (inputType) {
      case 'ghost':
        return 'hover:border-[1px] hover:border-f-purple border-[1px] border-transparent';
      default:
        return '';
    }
  };
}

interface Props extends HTMLProps<HTMLInputElement> {
  inputType?: InputType;
}

export type InputType = 'default' | 'ghost';

export default CustomInput;
